import { useState } from 'react';
import InventoryModal from './InventoryModal';
import { ContentPlaybackTimelineAudioTrack, FileWithProxy } from './video-player.types';
import VideoPlayerAdvanced, { VideoPlayerProps } from './VideoPlayerAdvanced';

type VideoWithInventoryModalProps = {} & VideoPlayerProps;

const VideoWithInventoryModal = (props: VideoWithInventoryModalProps) => {
  const [showAssetModal, setShowAssetModal] = useState<boolean>(false);
  const [customAssets, setCustomAssets] = useState<FileWithProxy[]>([]);
  const [dolbyVideoUrl, setDolbyVideoUrl] = useState<string | undefined>();
  const [dolbyAudioTracks, setDolbyAudioTracks] = useState<ContentPlaybackTimelineAudioTrack[]>([]);

  const onUpdateFiles = (files: FileWithProxy[], videoUrlFromDolby?: string, audioTracks?: ContentPlaybackTimelineAudioTrack[]) => {
    setCustomAssets(files);
    setDolbyVideoUrl(videoUrlFromDolby);
    setDolbyAudioTracks(audioTracks || []);
    setShowAssetModal(false);
  };

  return (
    <>
      <InventoryModal videoUrl={props.url} onUpdateFiles={onUpdateFiles} show={showAssetModal} onClose={() => setShowAssetModal(false)} />
      <VideoPlayerAdvanced
        {...props}
        waitForUrl={false}
        url={dolbyVideoUrl || props.url}
        onShowInventoryModal={() => setShowAssetModal(true)}
        externalAssets={customAssets}
        audioTracks={dolbyAudioTracks}
      />
    </>
  );
};

export default VideoWithInventoryModal;
